import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DropdownIcon = (props: SvgProps) => <Svg width='10' height='10' viewBox='0 0 10 10' fill='none' {...props}>
  <Path d='M1.25 3.75L5 7.5L8.75 3.75' fill={props.color ?? '#0058AD'} />
</Svg>;

export default DropdownIcon;
